import { render } from "./About.vue?vue&type=template&id=07d4843c&bindings={\"hello\":\"data\",\"showOutput\":\"data\",\"alertHello\":\"options\",\"hideOutput\":\"options\"}"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
script.render = render

export default script